import { injectScript } from './injectScript';
import { REACT_APP_UTAG_SYNC_URL, REACT_APP_UTAG_URL } from 'config';

export async function injectUtagScripts() {
  await injectScript(REACT_APP_UTAG_SYNC_URL);
  /*eslint-disable*/
  // @ts-ignore
  window.utag_data = {};
  (function (a, b, c, d) {
    // @ts-ignore
    a = REACT_APP_UTAG_URL; b = document; c = 'script'; d = b.createElement(c); d.src = a; d.type = 'text/java' + c; d.async = true;
    // @ts-ignore
    a = b.getElementsByTagName(c)[0]; a.parentNode.insertBefore(d, a);
  })();

  /*eslint-enable*/
}
